/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Customer_Payment_ErrorInputs */

const vi_toast_customer_payment_error = /** @type {(inputs: Toast_Customer_Payment_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghi nhận thanh toán thất bại`)
};

/**

* @param {Toast_Customer_Payment_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_customer_payment_error = /** @type {((inputs?: Toast_Customer_Payment_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Customer_Payment_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_customer_payment_error(inputs)
});